import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarketingPageHeader from "@/components/MarketingPageHeader";
import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqCategories = [
  {
    id: "getting-started",
    titleKey: "faq.categories.gettingStarted.title",
    items: [
      {
        questionKey: "faq.categories.gettingStarted.items.whatIsJynio.question",
        answerKey: "faq.categories.gettingStarted.items.whatIsJynio.answer",
      },
      {
        questionKey: "faq.categories.gettingStarted.items.howSignUp.question",
        answerKey: "faq.categories.gettingStarted.items.howSignUp.answer",
      },
      {
        questionKey: "faq.categories.gettingStarted.items.whichLanguages.question",
        answerKey: "faq.categories.gettingStarted.items.whichLanguages.answer",
      },
    ],
  },
  {
    id: "booking-sessions",
    titleKey: "faq.categories.bookingSessions.title",
    items: [
      {
        questionKey: "faq.categories.bookingSessions.items.howBook.question",
        answerKey: "faq.categories.bookingSessions.items.howBook.answer",
      },
      {
        questionKey: "faq.categories.bookingSessions.items.howLong.question",
        answerKey: "faq.categories.bookingSessions.items.howLong.answer",
      },
      {
        questionKey: "faq.categories.bookingSessions.items.reschedule.question",
        answerKey: "faq.categories.bookingSessions.items.reschedule.answer",
      },
      {
        questionKey: "faq.categories.bookingSessions.items.noShow.question",
        answerKey: "faq.categories.bookingSessions.items.noShow.answer",
      },
    ],
  },
  {
    id: "credits-pricing",
    titleKey: "faq.categories.creditsPricing.title",
    items: [
      {
        questionKey: "faq.categories.creditsPricing.items.howCredits.question",
        answerKey: "faq.categories.creditsPricing.items.howCredits.answer",
      },
      {
        questionKey: "faq.categories.creditsPricing.items.packages.question",
        answerKey: "faq.categories.creditsPricing.items.packages.answer",
      },
      {
        questionKey: "faq.categories.creditsPricing.items.expire.question",
        answerKey: "faq.categories.creditsPricing.items.expire.answer",
      },
    ],
  },
  {
    id: "for-tutors",
    titleKey: "faq.categories.forTutors.title",
    items: [
      {
        questionKey: "faq.categories.forTutors.items.becomeTutor.question",
        answerKey: "faq.categories.forTutors.items.becomeTutor.answer",
      },
      {
        questionKey: "faq.categories.forTutors.items.getPaid.question",
        answerKey: "faq.categories.forTutors.items.getPaid.answer",
      },
      {
        questionKey: "faq.categories.forTutors.items.scheduleRates.question",
        answerKey: "faq.categories.forTutors.items.scheduleRates.answer",
      },
      {
        questionKey: "faq.categories.forTutors.items.displayName.question",
        answerKey: "faq.categories.forTutors.items.displayName.answer",
      },
    ],
  },
  {
    id: "technical-account",
    titleKey: "faq.categories.technicalAccount.title",
    items: [
      {
        questionKey: "faq.categories.technicalAccount.items.liveSession.question",
        answerKey: "faq.categories.technicalAccount.items.liveSession.answer",
      },
      {
        questionKey: "faq.categories.technicalAccount.items.resetPassword.question",
        answerKey: "faq.categories.technicalAccount.items.resetPassword.answer",
      },
      {
        questionKey: "faq.categories.technicalAccount.items.contactSupport.question",
        answerKey: "faq.categories.technicalAccount.items.contactSupport.answer",
      },
    ],
  },
];

const FAQ = () => {
  const { t } = useTranslation();

  return (
  <div className="min-h-screen bg-background">
    <Header />
    <MarketingPageHeader title={t("faq.heading")} subtitle={t("faq.subheading")} containerClassName="max-w-3xl" />
    <main className="container mx-auto px-4 pb-24 pt-6 max-w-3xl">
      <div className="space-y-10">
        {faqCategories.map((category) => (
          <section key={category.id}>
            <h2 className="text-lg font-semibold text-foreground mb-4">
              {t(category.titleKey)}
            </h2>
            <Accordion type="single" collapsible className="w-full">
              {category.items.map((item, index) => (
                <AccordionItem
                  key={index}
                  value={`${category.id}-${index}`}
                >
                  <AccordionTrigger className="text-left">
                    {t(item.questionKey)}
                  </AccordionTrigger>
                  <AccordionContent forceMount className="text-muted-foreground">
                    {t(item.answerKey)}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </section>
        ))}
      </div>
    </main>
    <Footer />
  </div>
  );
};

export default FAQ;
